<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">入力内容確認</h1>
      <div class="l-contentsBox">
        <table class="l-form-table">
          <tr>
            <th class="v-middle"><span>社名</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.corpName }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>担当者名</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.responsibleName }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>部署名</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.deptName }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>メールアドレス</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.mailAddress }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>郵便番号</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.postCd }}</span>
            </td>
          </tr>

          <tr>
            <th class="v-middle"><span>都道府県</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ prefName }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>市区町村・番地</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.address2 }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>建物名・部屋番号など</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.address3 }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>電話番号</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.tel }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>電話番号(ご担当者様)</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.responsibleTel }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>FAX番号</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.faxNo }}</span>
            </td>
          </tr>
          <tr>
            <th class="v-middle"><span>ご紹介者様</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ form.introducerHonorificsName }}</span>
            </td>
          </tr>
          <!-- 利用プラン　-->
          <tr v-if="this.isSupple">
            <th class="v-middle"><span>利用プラン</span></th>
            <td class="v-middle">
              <span style="padding-left: 20px;">{{ usagePlanName }}</span>
            </td>
          </tr>          
          <tr>
            <th class="v-middle"><span>お問い合わせ・ご質問等</span></th>
            <td class="v-middle">
              <p style="padding-left: 20px; white-space: pre-line;">{{ form.comment }}</p>
            </td>
          </tr>
        </table>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()"><a>送信する</a></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import constant from '@/const';

export default {
  components: {
   Loading,
  },
  data()  {
    return {
      isProcessing: false,
      isSupple: false,
      form: {
        contactType: 1,
        corpName: '',
        responsibleName: '',
        mailAddress: '',
        tel: '',
        comment: '',
        deptName: '',
        responsibleTel: '',
        postCd: '',
        prefectureCd: '1',
        address2: '',
        address3: '',
        faxNo: '',
        introducerHonorificsName: '',
        usagePlanId: '',
      },
      contactTypeName: '',
      prefName: '',
      usagePlanName: '',
    }
  },
  created: async function() {
    this.form = await this.$store.getters['contactForm/getForm'];
    this.isSupple =  await this.$store.getters['contactForm/getIsSupple'];
    if (!this.form.corpName) {
      this.$router.push({ name: 'contact-form-input'});
      return;
    }
    this.isProcessing = true;
    const prefectureCd = this.form.prefectureCd;
    let selectedPrefecture = constant.PREFS.find(function(element) {
      return element.value === prefectureCd;
    }, prefectureCd);
    this.prefName = selectedPrefecture.label;

    if ( this.isSupple ) {
      let usageList = await this.getUsagePlanList();
      this.usagePlanName = usageList[this.form.usagePlanId].label;
    }
    this.isProcessing = false;
  },
  methods: {
    async register() {
      this.isProcessing = true;
      await this.$axios.get('/ld/sanctum/csrf-cookie')
        .catch(() => {
          return;
        });

      let res = await this.$axios.post('/ld/api/contact/contact_form/store', {
        contactForm: this.form,
        isSupple: this.isSupple // 「お問い合わせ・ご質問等」に問合せ元サービスを追記するために使用
      });
      if (res.status === 200) {
        if (!this.isSupple) {
          this.$router.push({ name: 'contact-form-complete' });
        }
        else {
          this.$router.push({ name: 'contact-form-complete', query: {supple: null} });
        }
      }
      this.isProcessing = false;
    },
    async getUsagePlanList() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/contact/contact_form/getUsagePlanList');
      if (res) {
        let usagePlanList = [];
        res.data.usagePlanList.forEach(u => {
          usagePlanList.push({
            value: u.usagePlanId,
            label: u.name + " 登録可能件数：" + u.maxCount + "件（¥"+u.amount.toLocaleString()+"/月）",
          });
        });
        return usagePlanList;
      }
      this.isProcessing = false;
    },
  }
}

</script>
